import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import React from 'react';
import { BiData } from '@wix/da-bi/pkg/events';
import SearchIcon from '@wix/da-ds/pkg/Icons/24x24/Search';
import SearchModal from '../../../_partials/SearchModal';
const SearchIconButton = ({ className , isSearchModalShown , openSearchModal , closeSearchModal  })=>{
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(IconButton, {
        className: className,
        size: "medium",
        icon: SearchIcon,
        biData: BiData({
            evid: 700,
            link_name: 'search'
        }),
        onClick: openSearchModal
    }), isSearchModalShown && /*#__PURE__*/ React.createElement(SearchModal, {
        onClose: closeSearchModal
    }));
};
SearchIconButton.displayName = 'SearchIconButton';
export default SearchIconButton;
